import { DocumentCard, PivotItem } from "@fluentui/react";
import { FluentProvider, webLightTheme } from "@fluentui/react-components";
import { Paper } from "@mui/material";
import { useSearchParams } from "react-router-dom";
import { TabsContainer } from "../../../SharedComponents/TabsContainer";
import { buildDisabledFeatureLookup } from "../../../Utils/js-common";
import { useGetUIEnablementsSettingsQuery } from "../../../slices/Home.slice";
import { PRODUCT_VIEW_DATA } from "../Common/ProductView.constants";
import { PRODUCT_VIEW_STYLES } from "../Common/ProductView.styles";

export const ProductViewTabsContainer = ( {productFamily} : { productFamily?: string } ) => {
  const {
    pivot: { ariaLabel },
    pivotItems
  } = PRODUCT_VIEW_DATA.TABS.DATA;
  const uiEnablementData = useGetUIEnablementsSettingsQuery(undefined)?.data || [];
  const disabled = buildDisabledFeatureLookup(uiEnablementData);
  const disabledTabs = disabled["tab"] || [];
  const revenueEnabledProductFamily = [
    "Microsoft Purview Consumption",
    "Microsoft Defender for Cloud",
    "Microsoft Sentinel",
    "Security Copilot"
  ];
  const filteredProductFamilies = pivotItems
    .filter(
      ({ headerText }) =>
        !disabledTabs
          .filter(({ feature }) => feature === "Explore Products")
          .map(({ tab }) => tab)
          .includes(headerText)
    )
    .filter(({ itemKey }) => {
      // Only include ConsumptionRevenueTab if productFamily is in revenueEnabledProductFamily
      if (itemKey === "ConsumptionRevenueTab" && productFamily) {
        return revenueEnabledProductFamily.includes(productFamily);
      }
      return true;
    });
  const renderTabs = filteredProductFamilies.map(({ headerText, itemKey, component: TabComponent }, index) => (
    <PivotItem headerText={headerText} itemKey={itemKey} key={`${itemKey + index}`}>
      {itemKey === "CohortsTab" ? <Paper><TabComponent /></Paper> : <TabComponent />}
    </PivotItem>
  ));
  const initialTabHeaderText = filteredProductFamilies[0]?.headerText || "";
  const [searchParams, setSearchParams] = useSearchParams();
  const selectedTab = searchParams.get("tab") || initialTabHeaderText;
  const selectedTabKey = filteredProductFamilies.filter(({ headerText }) => headerText === selectedTab)[0]?.itemKey;

  // Events
  const handleSelectedTab = (item?: PivotItem) => {
    if (item?.props.headerText) {
      setSearchParams((prev) => {
        const newParams = new URLSearchParams();

        // Preserve all existing parameters
        prev.forEach((value, key) => {
          newParams.set(key, value);
        });

        // Set the new tab
        newParams.set("tab", item.props.headerText || "");

        return newParams;
      });
    }
  };

  return (
    <DocumentCard styles={{ root: PRODUCT_VIEW_STYLES.OVERVIEW_SECTOIN.tabsCardRoot }}>
      <FluentProvider theme={webLightTheme}>
        <TabsContainer
          ariaLabel={ariaLabel}
          styles={PRODUCT_VIEW_STYLES.TABS_SECTION.pivotStyles}
          handleSelectedTab={handleSelectedTab}
          selectedKey={selectedTabKey}
        >
          {renderTabs}
        </TabsContainer>
      </FluentProvider>
    </DocumentCard>
  );
};
